import { MenuProvider } from './menu'
import { SellerProvider } from './seller'

const AppProvider = ({ children }) => {
  return (
    <MenuProvider>
      <SellerProvider>{children}</SellerProvider>
    </MenuProvider>
  )
}

export default AppProvider
